module.exports = __webpack_public_path__ + "assets/img/EKSElement-next-station.2c4949e2.svg";